<template>
  <div>
    <Modal
      v-model="shareBtnShow"
      title="分享"
      :footer-hide = "true"
      :mask-closable="false"
      width = "580"
      >
        <div style = "padding-bottom:20px;">
          <div class = 'link-content'>
            <div class = 'link-tit'>内部成员</div>
            <div class = 'link-notice'>内部成员访问该链接需要登录系统</div>
            <div class = 'input-content'>
              <div class = 'input-out'>
                <i-input ref = "inLink" v-model="inLink" disabled></i-input>
              </div>
              <span @click = "_copy(1)">复制</span>
              <span @click = "_openLink(1)">打开</span>
              <span style = "padding-right:0;" @click = "_makeQrcode(1)">二维码</span>
            </div>
          </div>
          <div class = 'link-content'>
            <div class = 'link-tit'>
              <span style = 'margin-right:10px;'>外部成员</span>
              <!-- <i-switch size = "small" v-model="outLinkInputShow"></i-switch> -->
            </div>
            <div class = 'link-notice' v-show = "outLinkInputShow">将表单中的数据发布为独立的公开链接，无需登录即可访问数据</div>
            <div class = 'input-content' v-show = "outLinkInputShow">
              <div class = 'input-out'>
                <i-input ref = "inLink" v-model="inLink" disabled></i-input>
              </div>
              <span @click = "_copy(2)">复制</span>
              <span @click = "_openLink(2)">打开</span>
              <span style = "padding-right:0;" @click = "_makeQrcode(2)">二维码</span>
            </div>
          </div>
        </div>
        <div class = 'codeimg-content' @click = "qrcodeShow = false" v-show = "qrcodeShow">
          <div class = "mask"></div>
          <div class = "img-content">
            <img id = "qrcode" :src = "qrcodeLink" />
          </div>
        </div>
    </Modal>
  </div>
</template>

<script>
const QRcode = require('qrcode')
import envConst from '@/env-const.js'
export default {
  props: {
    params: {}
  },
  data(){
    return {
      shareBtnShow: false,
      qrcodeShow: false,
      qrcodeLink: '',
      outLinkShow: false,
      outLinkInputShow: true,
      outLinkErrorTxt: ''
    }
  },
  created(){
    this._getState()
  },
  computed:{
    inLink(){
      let params = this.params || {}
      return `${window.location.origin}/scea_outlink_ui/#/2-${params.busType}-mtId-${params.mtId}`
    },
    outLink(){
      let params = this.params || {}
      return `${window.location.origin}/scea_outlink_ui/#/2-${params.busType}-outMtId-${params.mtId}`
    }
  },
  methods: {
    _getState(){
      //'/scmd/chain/getDetail/{sbtId}/chainType'
      this.$http
        .get(
          envConst.API_BASE_URL +
            `/scmd/chain/getDetail/${this.params.busType}/2`
        )
        .then(response => {
          if (response.data.returnCode == '0') {
            if(response.data.bean&&response.data.bean.DATA&&response.data.bean.DATA.state == '1'){
              this.outLinkShow = true
            }else if(response.data.bean&&response.data.bean.RESULT_MSG){
              this.outLinkErrorTxt = response.data.bean.RESULT_MSG
            }else{
              this.outLinkErrorTxt = "请先配置单条数据链接分享"
            }
          } else {
            this.$Message.error(response.data.returnMessage)
          }
        })
        .catch(error => {
          this.outLinkErrorTxt = "外链分享配置获取失败"
          this.$Message.error('外链分享配置获取失败')
        })
    },
    open(){
      if(!this.outLinkShow){
        // this.$Message.warning('请先配置单条数据链接分享')
        this.$Message.warning(this.outLinkErrorTxt)
        return
      }
      this.shareBtnShow = true
    },
    _openLink(type){
      let content = "";
      if(type == 1){
        content = this.inLink
      }else{
        content = this.outLink
      }
      window.open(content,'_blank')
    },
    _copy(type){
      let content = "";
      if(type == 1){
        content = this.inLink
      }else{
        content = this.outLink
      }
      var aux = document.createElement("input") 
      aux.setAttribute("value", content)
      document.body.appendChild(aux);
      aux.select()
      document.execCommand("copy")
      document.body.removeChild(aux)
      this.$Message.success('已复制到剪贴板')
    },
    _makeQrcode(type){
      let content = ""
      if(type == 1){
        content = this.inLink
      }else{
        content = this.outLink
      }
      console.log(QRcode)
      QRcode.toDataURL(content, (err, url) => {
        console.log(url)
        this.qrcodeLink = url
        this.$nextTick(()=>{
          this.qrcodeShow = true
        })
      })
    }
  }
  
}
</script>

<style scoped lang = "less">
  .link-content{
    padding: 10px 5px;
    .link-tit{
      color: #33344A;
      font-size:14px;
      font-weight: bold;
      padding-bottom:8px;
    }
    .link-notice{
      color:#9191A1;
      font-size:12px;
      padding-bottom: 10px;
    }
    .input-content{
      span{
        display: inline-block;
        vertical-align: middle;
        color:#00B8C4;
        padding-left:12px;
        font-size:14px;
        cursor: pointer;
      }
    }
    .input-out{
      display: inline-block;
      width:400px;
      vertical-align: middle;
    }
  }
  .codeimg-content{
    position:fixed;
    z-index: 99999;
    height:100%;
    width:100%;
    left:0;
    top:0;
    .mask{
      position:absolute;
      height:100%;
      width:100%;
      background:#333;
      left:0;
      top:0;
    }
    img{
      height:300px;
      width:300px;
      position:absolute;
      z-index:1;
      left:50%;
      top:50%;
      margin-left:-150px;
      margin-top:-150px;
    }
  }
</style>